import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { useSite } from "../../lib/site";
import { href } from "../../lib/i18n";

export function Loading() {
  return <div className="min-h-[50vh] flex items-center justify-center" data-testid="page-loading"><Loader2 className="animate-spin text-s-muted" /></div>;
}

export default function NotFound() {
  const { lang, ui } = useSite();
  const { pathname } = useLocation();
  const nav = useNavigate();
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    const path = lang === "tr" ? pathname : pathname.replace(/^\/[a-z]{2}/, "") || "/";
    api.get("/public/resolve", { params: { path } }).then((r) => {
      if (r.data.to?.startsWith("https://")) window.location.replace(r.data.to);
      else if (r.data.to) nav(lang === "tr" ? r.data.to : `/${lang}${r.data.to}`, { replace: true });
      else setChecked(true);
    }).catch(() => setChecked(true));
  }, [pathname, lang, nav]);
  if (!checked) return <Loading />;
  return (
    <section className="max-w-3xl mx-auto px-6 py-32 text-center" data-testid="not-found">
      <title>404</title>
      <meta name="robots" content="noindex" />
      <p className="font-signature text-8xl text-s-primary">404</p>
      <h1 className="font-heading text-3xl mt-6">{ui.notFound}</h1>
      <Link to={href(lang, "home")} className="inline-flex mt-10 rounded-[var(--s-radius)] bg-s-primary text-s-onprimary px-7 py-3 font-semibold" data-testid="not-found-home-link">{ui.backHome}</Link>
    </section>
  );
}
